import type { ITextFieldStyles } from "@fluentui/react";
import { memoizeFunction } from "@fluentui/react";

import type { ActionControlSize } from "@1js/acui-common";

const getSmallInputStyles = (): Partial<ITextFieldStyles> => {
  return {
    root: {
      height: 24,
    },
    fieldGroup: {
      height: 22,
    },
    subComponentStyles: {
      label: {
        root: {
          fontSize: "12px",
          padding: "0px",
          marginTop: "2px",
          lineHeight: "inherit",
        },
      },
    },
  };
};

export const getInputSizedStyles = memoizeFunction(
  (size: ActionControlSize | undefined): Partial<ITextFieldStyles> => {
    return size ? getSmallInputStyles() : {};
  }
);
